type PathItem = {
  [key in string]: number | string | boolean | string[] | undefined;
};

type PathType = PathItem | PathItem[];

export const useDownloadJson = () => {
  const downloadJson = (path: PathType) => {
    const fileName = 'data.json';
    const data = new Blob([JSON.stringify(path)], {
      type: 'text/json',
    });
    const jsonURL = window.URL.createObjectURL(data);
    const link = document.createElement('a');
    document.body.appendChild(link);
    link.href = jsonURL;
    link.setAttribute('download', fileName);
    link.click();
    document.body.removeChild(link);
  };

  return {
    downloadJson,
  };
};
